/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService
 */
import * as References from './PublicScopeGapsService';
import { createRpcClientV2 } from 'rpc-client-utils';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { registerQuery } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: noAuthHttp
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService#getProductHierarchy
 */
export const GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_PublicScopeGapsService_getProductHierarchy';
export const GET_PRODUCT_HIERARCHY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME,
  args: ['frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getProductHierarchyRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService#getSatisfyingOptions
 */
export const GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_PublicScopeGapsService_getSatisfyingOptions';
export const GET_SATISFYING_OPTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME,
  args: ['scopes', 'scopeGroups', 'minimal', 'frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getSatisfyingOptionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService#getSatisfyingCombos
 */
export const GET_SATISFYING_COMBOS_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_PublicScopeGapsService_getSatisfyingCombos';
export const GET_SATISFYING_COMBOS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_COMBOS_QUERY_FIELD_NAME,
  args: ['scopes', 'scopeGroups', 'minimal', 'frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getSatisfyingCombosRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.PublicScopeGapsService#getSatisfyingCombosBatch
 */
export const GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME = 'com_hubspot_scopegaps_rpc_PublicScopeGapsService_getSatisfyingCombosBatch';
export const GET_SATISFYING_COMBOS_BATCH_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getSatisfyingCombosBatchRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});